export enum Roles {
  basfUser = "ROLE_BASF_USER",
  distributor = "ROLE_DISTRIBUTOR",
}
